// src/components/Home.tsx
import React from 'react';
import { Container, Typography, Button, Box, Link } from '@mui/material';
import appimg from '../FFApp.png';
import distractedimg from '../Distracted.png';
import appleIcon from '../appleicon.png';
import windowsIcon from '../windowsicon.png';

const Home: React.FC = () => {
  return (
    <div style={{ backgroundColor: '#001f3f', minHeight: '100vh', color: 'beige' }}>
      <Container maxWidth="md" style={{ textAlign: 'center', paddingTop: '100px' }}>
        <Typography variant="h2" component="h1" gutterBottom>
          Welcome to Full Focus
        </Typography>
        
        <Typography variant="h5" component="p" gutterBottom>
          Enhance your on-screen productivity by detecting distractions.
        </Typography>

        {/* Button Section */}
        <Box display="flex" justifyContent="center" gap="10px" mt={2}>
          <Button
            variant="contained"
            href="https://full-focus-download.s3.us-east-2.amazonaws.com/FullFocus.exe"
            download 
            style={{ backgroundColor: 'beige', color: '#001f3f', display: 'flex', alignItems: 'center' }}
          >
            Download for Windows
            <img src={windowsIcon} alt="Windows Icon" style={{ width: '20px', marginLeft: '8px' }} />
          </Button>
          <Button
            variant="contained"
            href="https://full-focus-mac-download.s3.us-east-2.amazonaws.com/FullFocus.zip"
            download
            style={{ backgroundColor: 'beige', color: '#001f3f', display: 'flex', alignItems: 'center' }}
          >
            Download for Mac
            <img src={appleIcon} alt="Apple Icon" style={{ width: '20px', marginLeft: '8px' }} />
          </Button>
        </Box>
{/* MacOS Installation Message */}
<Box
  style={{
    marginTop: '10px',
    display: 'flex',
    justifyContent: 'center', // Centers horizontally
    alignItems: 'center',     // Centers vertically (if needed)
  }}
>
  <Box
    border="1px solid beige"
    borderRadius="2px"
    padding="8px"
    bgcolor="#021526"
    style={{
      width: '80%',
      maxWidth: '600px', // Optional: Limit the box's maximum width
      textAlign: 'center', // Centers the text inside the box
    }}
  >
    <Typography variant="body1" component="p" style={{ color: 'beige' }}>
      <strong>*Please refer to instructions for MacOS installation.*</strong>
    </Typography>
  </Box>
</Box>


        {/* Feature List Section */}
        <Box mt={6} textAlign="left">
          <Typography variant="h4" component="p" style={{ color: 'beige' }}>
            With Full Focus, you can:
          </Typography>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px', marginTop: '10px', color: 'beige' }}>
            <li>
              <Typography variant="h6" component="p">
                Detect distractions in real-time with advanced eye and blink tracking.
              </Typography>
            </li>
            <li>
              <Typography variant="h6" component="p">
                Set customizable thresholds to personalize detection sensitivity to suit your focus needs.
              </Typography>
            </li>
            <li>
              <Typography variant="h6" component="p">
                Receive gentle audio alerts when you become distracted, helping you refocus quickly.
              </Typography>
            </li>
            <li>
              <Typography variant="h6" component="p">
                Track your study sessions with metrics on focus and distraction times, so you can measure your improvement.
              </Typography>
            </li>
            <li>
              <Typography variant="h6" component="p">
                Easily adjust detection delay and alert frequency for a distraction-free and personalized study experience.
              </Typography>
            </li>
            <li>
              <Typography variant="h6" component="p">
                And it's completely free of charge!
              </Typography>
            </li>
          </ul>
        </Box>

        {/* App Image Section */}
        <Box mt={6} textAlign="left">
          <Typography variant="h4" component="p" style={{ color: 'beige', marginBottom: '10px' }}>
            The App:
          </Typography>
        </Box>

        <Box mt={4} display="flex" justifyContent="center">
          <img src={appimg} alt="Full Focus App Preview" style={{ width: '100%', maxWidth: '500px', borderRadius: '8px' }} />
        </Box>

        {/* Getting Started Section */}
        <Box mt={6} textAlign="left">
          <Typography variant="h4" component="p" style={{ color: 'beige', marginBottom: '10px' }}>
            Getting Started
          </Typography>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px', color: 'beige' }}>
            <li>
              <Typography variant="body1" component="p">
                <strong>Set Thresholds:</strong> Adjust the sliders to control the app's sensitivity. Default values are recommended for optimal performance.
              </Typography>
            </li>
            <li>
              <Typography variant="body1" component="p">
                <strong>Configure Audio Settings:</strong> Set a delay for the audio alert after detection, and specify how often it repeats if you remain distracted.
              </Typography>
            </li>
            <li>
              <Typography variant="body1" component="p">
                <strong>Select Audio File:</strong> Optionally, upload an audio file to play as an alert when you become distracted.
              </Typography>
            </li>

            {/* New Note with Link */}
            <li style={{ marginTop: '20px' }}>
              <Box border="1px solid beige" borderRadius="8px" padding="10px" bgcolor="#021526">
                <Typography variant="body1" component="p" style={{ color: 'beige' }}>
                  For a personalized alert sound, you can visit 
                  {' '}<Link href="https://ttsmp3.com/ai" target="_blank" style={{ color: '#6EACDA', fontWeight: 'bold' }}>
                    ttsmp3.com/ai
                  </Link>{' '}
                  to download a custom text-to-speech file, or be like me and record your own voice shouting profanities to keep you on track!
                </Typography>
              </Box>
            </li>

            <li>
              <Typography variant="body1" component="p">
                <strong>Start Detection:</strong> Click "Start Detection" to begin monitoring. You can run the app in the background and hear the alert if you get distracted.
              </Typography>
            </li>
            <li>
              <Typography variant="body1" component="p">
                <strong>View Metrics:</strong> After stopping detection, review your session metrics, including focus time, distraction time, and session duration.
              </Typography>
            </li>
          </ul>
        </Box>

        {/* Continue with remaining sections */}
        <Box mt={6} textAlign="center">
          <Typography variant="h4" component="p" style={{ color: 'beige', marginBottom: '10px' }}>
            Example Distraction Detection
          </Typography>
          <Typography variant="h5" component="p" style={{ color: 'beige', marginBottom: '20px' }}>
            <strong>Disclaimer: </strong> I realize it may look a little scary, but I will be adding new features to let users toggle the circles and customize the colours!
          </Typography>
          <img src={distractedimg} alt="Distracted State Example" style={{ width: '100%', maxWidth: '500px', borderRadius: '8px', border: '2px solid beige' }} />
        </Box>
        <Typography variant="body1" component="p" style={{ color: 'beige', marginBottom: '20px' }}>
          In the image above, the red circles indicate that the user is distracted. When focused, the circles will appear in white.
        </Typography>
      </Container>
    </div>
  );
};

export default Home;
